export const getIsADS12859Enabled = ({ isUsed, isPreprod, mobile, ads12859Recipe }) => {
  return !isUsed && !isPreprod && mobile && ['chal1', 'chal2'].includes(ads12859Recipe);
};
